import { render, staticRenderFns } from "./PlatformSelect.vue?vue&type=template&id=5157f90b&scoped=true"
import script from "./PlatformSelect.vue?vue&type=script&lang=js"
export * from "./PlatformSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157f90b",
  null
  
)

export default component.exports